import axios from 'axios'
import {API} from 'src/feature/bite/domain'
import Swal from 'sweetalert2'

interface CityListResponse {
  response: {
    cities: {
      id: string
      name: string
    }[]
  }
}

/* export default async function getCities(countryId: string) {
  const response = await axios.post<CityListResponse>(
    `${API}/City/GetCitiesbyCountry`,
    {
      countryId,
    }
  )
  return response.data.response.cities
} */

export default async function getCities(countryId: string) {
  const apiUrl = process.env.REACT_APP_API_URL
  const response = await axios.post<any>(`${apiUrl}/City/GetAllCity`, {
    countryID: countryId,
    paging: {
      currentPageNumber: 1,
      pageSize: 10000,
    },
  })
  return response.data.response.data
}
